export const LEFT_SIDE_NAV_WIDTH_PX = 220
export const LEFT_SIDE_NAV_WIDTH = `${LEFT_SIDE_NAV_WIDTH_PX}px`
